<template>
		<div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back" >
          <img width="40" src="../../static/images/back2.png" />
        </div>
        {{$t('Basic Chinese Challenge')}}
      </div>
    </div>
			<div class="home-content crfff">
        <div class="info">
          <div class="game-list mt30">
            <div v-if="gameList && gameList.length === 0" class="empty-message ac">
              {{$t('NoGameList')}}
            </div>
            <div class="li disflex" v-for="(item,index) in gameList" v-else  @click="goBattleRoom(item)">
              <div class="li-t2">
                <img class="li-img" src="../../static/images/cup.png" />
                <div class="li-re" v-if="item.task_status!==2">
                  <div class="lock" v-if="item.task_status==3">
                    <img src="../../static/images/lock.png">
                  </div>
                  <div class="star" v-if="item.task_status==1">
                    <img v-if="item.task_stars==0" src="../../static/images/0star.png">
                    <img v-if="item.task_stars==1" src="../../static/images/1star.png">
                    <img v-if="item.task_stars==2" src="../../static/images/2star.png">
                    <img v-if="item.task_stars==3" src="../../static/images/3star.png">
                  </div>
                    <div class="li-bg"></div>
                </div>
              </div>
              <div class="li-r disflex">
                <div class="li-c">
                  <div class="game-t font-family">{{item.task_name_text}}</div>
                  <div class="li-tip" :class="{'red':item.task_status==3,'yellow':item.task_status==2,'green':item.task_status==1}">
                    {{item.task_status_text}}
                  </div>
                </div>
                <div class="li-b">
                  <button class="button" :class="{'red':item.task_status==3,'yellow':item.task_status==2,'green':item.task_status==1}">{{item.button_text}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        gameList:null
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {
		back(){
			this.$router.push({path:'/',query: {}});
		},

    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/task/get_task_list',null,r =>{
        that.$parent.returnCode(r,function(){
          that.gameList = r.data
          that.$parent.loadModal(false);
        })
      })
    },
    goBattleRoom(item){
      if(item.task_status==3){
        this.$utils.alertText(this.$t('ChallengeTips'))
        return;
      }
       this.$router.push({path:'/ChallengeLearn',query:{id:item.id}});
    },
	}
}
</script>
<style>
.empty-message {
  padding: 100px 0;
  font-size: 24px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/page/Challenge.vue